import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => (
  <div className="ij-container ij-section">
    <Helmet>
      <title>Page not found — Indian Jewelryish</title>
      <meta name="robots" content="noindex" />
    </Helmet>

    <div className="ij-state">
      <p className="ij-state__title">We couldn&apos;t find that page</p>
      <p className="ij-state__body">
        The link may be broken, or the page may have been moved.
      </p>
      <div style={{ display: 'flex', gap: 'var(--ij-space-3)', flexWrap: 'wrap', justifyContent: 'center' }}>
        <Link to="/" className="ij-btn ij-btn--primary">
          Back to home
        </Link>
        <Link to="/allproducts" className="ij-btn ij-btn--outline">
          Shop all products
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
